'use client'

import { createContext, useContext, type ReactNode } from 'react'
import type { RowSurface } from './RowTemplateTypes'

// The surface seam (25_SHARED_DESKUI_SKELETON.md §5): each surface provides
// its leaves (recursion row, variant registry, config, skin) once around its
// row/view area. The skeleton reads this context and never imports a surface.

const RowSurfaceContext = createContext<RowSurface | null>(null)

export function RowSurfaceProvider({ value, children }: { value: RowSurface; children: ReactNode }) {
  return <RowSurfaceContext.Provider value={value}>{children}</RowSurfaceContext.Provider>
}

export function useRowSurface(): RowSurface {
  const surface = useContext(RowSurfaceContext)
  if (!surface) {
    throw new Error('useRowSurface: no RowSurfaceProvider is mounted above this row skeleton element')
  }
  return surface
}

export function useRowSurfaceOptional(): RowSurface | null {
  return useContext(RowSurfaceContext)
}
